<script>
import {mapActions, mapState} from 'vuex';
import { WEBSOCKET } from '@config/constants.js';

export default {
  data() {
    return {
      connected: false,
    }
  },
  watch: {
    uid: function (newVal) {
      if (!this.$socket || this.$socket.readyState === this.$socket.OPEN) {
        this.connect();
      }
    },
  },
  created: function(){
    const that = this;
    this.$socket.onmessage = function (msg) {
      const data = JSON.parse(msg.data);
      if(data["game-result"] !== undefined){
        const game = data["game-result"];
        const groupName = game.table.groupName;
        // HANDLER RESULT HANDLER
        switch(groupName){
          case "bacarat":
            if(game.table.id === 76 ||
              game.table.id === 73 ||
              game.table.id === 74 ||
              game.table.id === 75
            ){
              that.setBaccaratNewResult(game);
            }
            break;
          case "big-small":
            if(game.table.id === 77
            ){
              that.setTaiXiuNewResult(game);
            }
            break;
          case "soc-dia":
            if(game.table.id === 78
            ){
              that.setXocDiaNewResult(game);
            }
            break;
        }
      }
      else if(data["create-game"] !== undefined){
        const game = data["create-game"];
        const groupName = game.table.groupName;
        // HANDLER RESULT HANDLER
        switch(groupName){
          case "bacarat":
            if(game.table.id === 76 ||
              game.table.id === 73 ||
              game.table.id === 74 ||
              game.table.id === 75
            ){
              that.setBaccaratNewGame(game);
            }
            break;
          case "big-small":
            if(game.table.id === 77
            ){
              that.setTaiXiuNewGame(game);
            }
            break;
          case "soc-dia":
            if(game.table.id === 78
            ){
              that.setXocDiaNewGame(game);
            }
            break;
        }
      }
      // BALANCE
      else if(data.balance !== undefined){
        console.info("[WS] balance");
        that.setBalance(data.balance);
      }

    }

    this.$socket.onclose = function (msg) {
      console.log("[WS] onclose");

      if (!that.$socket || that.$socket.readyState !== that.$socket.OPEN) {
        // TODO: reconnect
        console.log("[WS] reconnect");
        // that.connect();
        // that.$router.push('/sessionout');
        location.reload();
      }
    };

    // ping every 5s
    setInterval(function(){
      console.log("[WS] ping");
      that.connect();

      if (that.$socket && that.$socket.readyState === that.$socket.OPEN) {
        that.$socket.send(JSON.stringify({'ping' : that.uid}));
      }
    }, WEBSOCKET.PING_TIME);
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapState('user', ['uid']),
  },
  methods: {
    ...mapActions('baccarat', {
      'setBaccaratNewResult': 'setNewResult',
      'setBaccaratNewGame': 'setNewGame'
    }),
    ...mapActions('taixiu', {
      'setTaiXiuNewResult': 'setNewResult',
      'setTaiXiuNewGame': 'setNewGame'
    }),
    ...mapActions('xocdia', {
      'setXocDiaNewResult': 'setNewResult',
      'setXocDiaNewGame': 'setNewGame'
    }),
    ...mapActions('user', ['setBalance']),
    connect: function() {
      if(this.connected === false && this.uid !== ""){
        if (!this.$socket || this.$socket.readyState === this.$socket.OPEN) {
          this.$socket.send(JSON.stringify({'connect' : this.uid}));
          this.connected = true;
        }
      }
    }
  }
}
</script>

<template>
  <div />
</template>
